import request from "@/service/request";

// 获取城市地区列表
export function getSelectorCity() {
  return request({
    url: "/selector/city",
    method: "get"
  });
}